import { ComponentChild, CSSProperties } from 'outpost/preact';
import { BoardCardTooltipComponent } from './board-card-tooltip-component.tsx';
import { BoardInspectZoneComponent } from './board-inspect-zone-component.tsx';
import { BoardLocalData } from './board-local-data.ts';
import { BoardPlayer } from './board-types.ts';
import { BoardZoneComponent } from './board-zone-component.tsx';
import { makeArray } from 'outpost';

export type BoardPlayerComponentProps = {
    style?: CSSProperties;
    localData: BoardLocalData;
    player: BoardPlayer;
};

export function BoardPlayerComponent(props: BoardPlayerComponentProps) {
    let { localData, player } = props;
    let board = localData.project.board;
    let rowCount = board.rows.length;
    let columnCount = Math.max(...board.rows.map(list => list.reduce((acc, item) => item.size + acc, 0)));
    let rows = makeArray(rowCount, () => '1fr').join(' ');
    let columns = makeArray(columnCount, () => '1fr').join(' ');

    let style: CSSProperties = {
        position: 'relative',
        display: 'grid',
        gridTemplateColumns: columns,
        gridTemplateRows: rows,
        gap: '10px',
        flexGrow: 1,
        ...props.style,
    };

    style.gridTemplateRows = rows;

    let isSelf = player.playerId === localData.playerId;
    let zoneComponents: ComponentChild[] = [];

    for (let i = 0; i < board.rows.length; ++i) {
        let row = board.rows[i];
        let x = i + 1;
        let y = 1;

        if (!isSelf) {
            x = board.rows.length - i;
        }

        for (let item of row) {
            let nextY = y + item.size;
            let gridRow = `${x} / ${x + 1}`;
            let gridColumn = `${y} / ${nextY}`;
            let zone = player.zones.find(zone => zone.metadata.label === item.label)!;
            let component = <BoardZoneComponent
                localData={localData}
                zone={zone}
                style={{
                    gridRow,
                    gridColumn,
                }}
            />;

            zoneComponents.push(component);
            y = nextY;
        }
    }

    return (
        <div style={style}>
            {...zoneComponents}
            <BoardInspectZoneComponent
                localData={localData}
                sideId={player.playerId}
            />
            <BoardCardTooltipComponent
                localData={localData}
                sideId={player.playerId}
            />
        </div>
    );
};